<template lang="pug">
#sub-empresa-alertas-contratos
    section.alerta-bloco__esquerda
        slot

    section
        .alerta-bloco__icone(@click='ocutarAlerta()')
            i.mdi.mdi-close
</template>

<script>
export default {
    name: 'SubEmpresaAlertasContratos',
    methods: {
        ocutarAlerta() {
            this.$emit('ocultar');
        }
    }
};
</script>

<style lang="scss">
#sub-empresa-alertas-contratos {
    border-left: 8px solid #ddac44;
    background: #fbfbfb;
    height: 56px;
    border-radius: 8px;
    display: flex;
    padding: 5px;
    padding-left: 14px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .alerta-bloco__esquerda {
        display: flex;
        align-items: center;
        height: 100%;
        flex-wrap: wrap;
        color: #3b3b3b;
        font-weight: 600;

        span {
            font-size: 22px;
            color: #3b3b3b;
            margin-right: 10px;
        }

        .link {
            color: #3fb1f2;
            margin-left: 6px;
            cursor: pointer;
            text-decoration: underline;
        }

        .link:hover {
            color: #ddac44;
        }
    }
    .alerta-bloco__icone {
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .alerta-bloco__icone:hover {
        color: #ff0000;
    }
}
</style>
